import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import MainLayOut from "../MainLayOut/MainLayOut";
import Header from "./Header";
import CourseDetailRightPaenl from "./CourseDetailRightPaenl";
import TabPanel from "./TabPanel";
import LessonContentLeft from "./LessonContentLeft";
import CharacterContentLeft from "./CharacterContentLeft";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { dashBoardCourseGoal, getCoursesInformation, getPlanUserCourse, getSctNotificationCount, getSocialActivityDetail, Knowladgecheck, NextScene, sctNotificationDetail, userCoupanOffer } from "../../redux/actions/APIs";
import { getCapitalized, getLoginType, getSequnceSort, getUrlSegment } from "../../utils/helper";
import { ShimmerCategoryList } from "react-shimmer-effects";
import CourseAbout from "./CourseAbout";
import correct from "../../resources/sound/right.mp3";
import wrong from "../../resources/sound/wrong.mp3";
//  import inspiring from "../../resources/sound/inspiring.mp3";

import useSound from "use-sound";
import LessonModuleChallenge from "../dimensions/course/social/LessonModuleChallenge";
import { breadcrumb, showModal } from "../../redux/actions";
import CongratulationCard from "../widget/CongratulationCard";
import LessonCongratulationsPopup from "../dimensions/course/vickycourses/LessonCongratulationsPopup";
import Newmodulelesson from "../dimensions/course/social/Newmodulelesson";
import { SITEURLNAME } from "../../utils/Messages";
import SctStatus from "./SctStatus";
const CourseDetail = () => {
    const params = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();

    const {
        defaultChildData,
        socialActivityData,
        loggedInUser,
        courseInformationData,
        next_scene_response,
        knowladge_check_response,
        dashBoardCourseGoalData,
        getPlanUserCourseResp,
    } = useSelector((state) => state.collections);
    const [getTab, setTab] = useState("Lessons");
    const [currentSceneObj, setCurrecntSceneObj] = useState();
    const [currecntScene, setCurrentScene] = useState(-1);
    const [getMyActivity, setMyActivity] = useState();
    const [getCount, setCount] = useState(0);
    const [showProgress, setShowProgress] = useState(0);
    const [userPoint, setUserPoint] = useState(0);
    const loginType = getLoginType(loggedInUser);
    const [isBlink, setIsBlink] = useState(false);  
    const [showCongratulationModel, setShowCongratulationModel] = useState(false);
    const [congratulationPopup, setCongratulationPopup] = useState(false);
    const [courseActivityId, setCourseActivityId] = useState([]);  

    //  Sound
    const [correctSound] = useSound(correct);
    const [wrongSound] = useSound(wrong);
   
    
    const currentCourse = location?.state?.course;

    // console.log("location?.state  : ",currentCourse ,  getUrlSegment(), getPlanUserCourseResp, dashBoardCourseGoalData);


    useEffect(()=>{
        if(!currentCourse && loggedInUser?.id && defaultChildData?.id){
             dispatch(getPlanUserCourse(loggedInUser?.id, defaultChildData?.id, params?.courseId));
        }   
    },[defaultChildData])

    useEffect(()=>{
        let pathArr = getUrlSegment();
        if(pathArr?.length === 4){
            if(pathArr[3] === "Reflection" || pathArr[3] === "Booster"){
            setTab("Reflection");
            }else if(pathArr[3] === "Challenge"){
                setTab("Challenges");
            }
        }
    },[location])

    useEffect(()=>{
        if(getPlanUserCourseResp && !currentCourse){
                history.replace({...history.location, state: {course: getPlanUserCourseResp?.records[0]}})     
                dispatch(getPlanUserCourse())
                
            }
    },[getPlanUserCourseResp])

    // console.log("currentCourse : ", currentCourse, getPlanUserCourseResp, socialActivityData);

    const hanldePointSound = () => {
        setIsBlink(true);
        correctSound();
        setTimeout(() => {
            setIsBlink(false);
        }, 3000)
    }

    useEffect(() => {
		window.scrollTo(0, 0);
	}, [])

    useEffect(()=>{
        dispatch(breadcrumb({ title: "🚀 My Plans" }));
    },[])

    useEffect(() => {
        if (defaultChildData?.id) {
            handleGetSocialAcitvityApi();
        }
    }, [defaultChildData])

    useEffect(() => {
        if (defaultChildData?.id && currentCourse?.planId) {
            let userId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : defaultChildData?.id;
            dispatch(dashBoardCourseGoal(userId, defaultChildData?.id, currentCourse?.planId));
        }
    },[defaultChildData, location])

    const handleGetSocialAcitvityApi = () => {
        dispatch(getSocialActivityDetail(loggedInUser?.id, defaultChildData?.id, params?.courseId, params?.activityId))
        dispatch(getCoursesInformation(defaultChildData?.id, params?.courseId));
    }

    const showNotification = ()=>{
            dispatch(getSctNotificationCount(loggedInUser?.id, defaultChildData?.id));
            dispatch(sctNotificationDetail(loggedInUser?.id, defaultChildData?.id));
    }

    useEffect(() => {
        if (socialActivityData?.records?.length > 0) {
            let myActivity = socialActivityData?.records[0];
            setCount(myActivity?.duration);
            setUserPoint(myActivity?.points);
            setShowProgress(myActivity?.courseModCompletion);
            if(getTab !== "Challenges"){
                setTab(myActivity?.isCompleted && !myActivity?.followUp?.isCompleted ? "Reflection" : "Lessons");
            }
        }
    }, [socialActivityData])

    useEffect(() => {
        if (socialActivityData?.records?.length > 0) {
            let getActivity = socialActivityData?.records[0];
            let tempScene =  currecntScene === -1 ? loginType ? getActivity?.currentScene - 1 : 0 : currecntScene;
            let sceneObj = getSequnceSort(getActivity?.series?.scenes)[tempScene];
            setMyActivity(getActivity);
            setCurrecntSceneObj(sceneObj);
            if(currecntScene === -1 ){
                setCurrentScene(tempScene);
            }
            // console.log("socialActivityData?.records?.length : ", currecntScene);
        }
    }, [socialActivityData, currecntScene])

    useEffect(() => {
        if(getMyActivity && !getMyActivity?.isCompleted && loggedInUser?.role?.name === "LEARNER"){
            const interval = setInterval(() => {
            setCount(prevCount => prevCount + 1);
             
            }, 1000);      // This sets the interval to 1000 milliseconds (1 second)
            // Clean up the interval on component unmount       
            return () => clearInterval(interval);
        }
    }, [getMyActivity]);

    console.log("getMyActivity : ", getCount,  getMyActivity?.duration, getMyActivity);

    const handleIsNext = (result) => {
        // console.log("handleIsNext : ", result, currecntScene);
        if (result && currecntScene + 1 < getMyActivity?.secScCount) {
            setCurrentScene(currecntScene + 1);
        } else if (!result && currecntScene > 0) {
            setCurrentScene(currecntScene - 1);
        }
    }

    const [getStartVideo, setStartVideo] = useState();

    /*
    window.addEventListener("click", (event) => {
        if (event?.target?.getAttribute('label') != null) {
            setStartVideo(event?.target?.getAttribute('label'));
        }
    });
    */

    window.addEventListener("click", (event) => {
        // console.log("window.addEventListener : ",event?.target, event?.target?.href, event?.target.title, event?.target?.getAttribute("target balnk"));
        const targetElement = event.target;
        const labeledParent = targetElement.closest("[label]");
        if (labeledParent) {
            const labelValue = labeledParent.getAttribute("label");
            //  console.log("Label value:", labelValue);
            if (labelValue) {
                setStartVideo(labelValue);
            }

        }
    });

    const handleMove = (index) => {
        setCurrentScene(index);
        if(getTab !== "Lessons"){
            setTab("Lessons");
        }
        
        
    }

    useEffect(() => {
        //  console.log("CourseDetail @@@", !getMyActivity?.isCompleted, getMyActivity?.series?.scenes?.every((item) => item?.isCompleted), currentSceneObj);
        if (!getMyActivity?.isCompleted && next_scene_response && getMyActivity?.series?.scenes?.every((item) => item?.isCompleted)) {
            // handleGetSocialAcitvityApi();
        }
        if (next_scene_response?.records?.length > 0) {
            setShowProgress(next_scene_response?.records[0]?.courseModCompletion);
            setUserPoint(next_scene_response?.records[0]?.points);
            hanldePointSound();
            if(getMyActivity?.rewardCPoints !== getMyActivity?.rewardCTargetPoints && 
                getMyActivity?.rewardCTargetPoints <= next_scene_response?.records[0]?.coursePoints){
                let rewardData = {
                    imageUrl: getMyActivity?.rcImageUrl,
                    rewardName: getMyActivity?.rcName,
		        };
                dispatch(showModal({type: "RewardUnlockPopup", rewardData: rewardData}));
                handleGetSocialAcitvityApi();
            }
            dispatch(NextScene());
        }
    }, [next_scene_response])

    // console.log("getMyActivity?.rewardCTargetPoints : ", getMyActivity?.rewardCTargetPoints, next_scene_response, knowladge_check_response);

   

    useEffect(() => {
        if (knowladge_check_response?.records?.length > 0) {
            setShowProgress(knowladge_check_response?.records[0]?.courseModCompletion);
            setUserPoint(knowladge_check_response?.records[0]?.points);
            if (userPoint !== knowladge_check_response?.records[0]?.points) {
                hanldePointSound();
            }
            if(loginType ){
                if(knowladge_check_response?.records[0]?.isActivityCompleted 
                    && getMyActivity?.series?.scenes?.length === currentSceneObj?.sequence && 
                    currentSceneObj?.kc?.every((item)=> item?.attempted )
                ){
                    if(getMyActivity?.isCompleted && getMyActivity?.followUp?.isCompleted){
                         showScorCardpopUp(
                            true,
                            [
                                defaultChildData?.id,
                                currentCourse?.id,
                                getMyActivity?.activityId,
                            ],
                            getMyActivity?.completion,
                            currentCourse
                        )
                        
                            setTab("Challenges");
                    }else{
                        setTab("Reflection");
                    }
                    handleGetSocialAcitvityApi();
                    showNotification();
                }

                if(getMyActivity?.rewardCPoints !== getMyActivity?.rewardCTargetPoints && 
                    getMyActivity?.rewardCTargetPoints <= knowladge_check_response?.records[0]?.coursePoints){
                let rewardData = {
                    imageUrl: getMyActivity?.rcImageUrl,
                    rewardName: getMyActivity?.rcName,
		        };
                dispatch(showModal({type: "RewardUnlockPopup", rewardData: rewardData}));
                handleGetSocialAcitvityApi();
            }
                
            }

            dispatch(Knowladgecheck());

        }
    }, [knowladge_check_response])

    


     const handlePlanGoals = () => {
        let myCourseObj = dashBoardCourseGoalData?.records?.find((course) => course?.courseId === currentCourse?.id);
        let dashBoardPlanData = { ...dashBoardCourseGoalData, records: [myCourseObj] };
        dashBoardPlanData.planId = currentCourse?.planId;
        dispatch(showModal({
            type: "PlanGoals", dashBoardPlanData: dashBoardPlanData, childData: defaultChildData
        }));
    }

    useEffect(()=>{
        if(dashBoardCourseGoalData?.records?.length > 0 && currentCourse){
            let myCourseObj = dashBoardCourseGoalData?.records?.find((course) => course?.courseId === currentCourse?.id);
            currentCourse.isDefinedGoal =  myCourseObj?.isDefinedGoal;
        }
    },[dashBoardCourseGoalData])

  
    const isShowLesson = ()=>{
        let isNext = false;
        if(currecntScene + 1 === getMyActivity?.secScCount){
            isNext = true;
        }
        if(loginType && !currentSceneObj?.isCompleted){
            isNext = true;
        }if (loginType && currentSceneObj?.kc?.length > 0 && currentSceneObj?.kc?.some((item)=> !item?.attempted )){
            isNext = true;
        }
        return isNext;
    }

    const showScorCardpopUp = (result, data, completion, course) => {
		if (result && completion > 0) {
			if (course?.isAcademic) {
				setCongratulationPopup(result);
			} else {
				setShowCongratulationModel(result);
			}
			setCourseActivityId(data);
		} else {
			setCongratulationPopup(false);
			setShowCongratulationModel(false);
			setCourseActivityId([]);
		}
	};

    return (
        <MainLayOut>
            <div className="Content_part flexsix w-100 pt-4 coursedetailslayout">
                <div className="leftpannel">
                    {socialActivityData?.records?.length > 0  ? (
                        <div className="myplan_listitems">
                            <Header
                                activityData={getMyActivity}
                                currentSceneObj={currentSceneObj}
                                handleMove={handleMove}
                                loginType={loginType}
                                getTab={getTab}
                                
                            />
                            <div className="LeftpanelContent">
                                <TabPanel
                                    getTab={getTab}
                                    setTab={setTab}
                                    activityData={getMyActivity}
                                    loginType={loginType}
                                />
                                {/* {getTab === "Lessons" && (
                                  <div className="video_container">
                                       <div className="video_icons">
                                           <img src={image.Video_btn} alt="videoicon"/>
                                       </div>
                                       <video src={currentSceneObj?.videourl} preload="auto" controls="" controlslist="nodownload" className="w-100 br-18"></video>
                                  </div>
                              )} */}

                                {getTab === "Lessons" ? (
                                    <LessonContentLeft
                                        loggedInUser={loggedInUser}
                                        defaultChildData={defaultChildData}
                                        currentSceneObj={currentSceneObj}
                                        getMyActivity={getMyActivity}
                                        getCount={getCount}
                                        loginType={loginType}
                                    />
                                ) :  getTab === "Characters" ? (
                                    <CharacterContentLeft
                                        charImage={getMyActivity?.series?.charImage}
                                        getStartVideo={getStartVideo}
                                    />
                                ) : getTab === "Reflection" ? (
                                        <SctStatus 
                                            activityData={getMyActivity}
                                            currentSceneObj={currentSceneObj}
                                        />
                                ) : (
                                        <>
                                            {/* {window.location.hostname === SITEURLNAME.urlName ? (
                                                <LessonModuleChallenge />
                                            ): (
                                                    <Newmodulelesson getMyActivity={getMyActivity}/>
                                            )}       */}
                                            <Newmodulelesson getMyActivity={getMyActivity}/>
                                        </> 
                                )}

                            </div>
                            {getTab === "Lessons" && (
                                <>
                                    <div className="next_prevlist w-100 flex mt-3 px-3 pt-3 pb-3">
                                        <a href="javascript:void(0);"
                                            className={`${currecntScene === 0 ? "disabledevent" : ""}`}
                                            onClick={() => { currecntScene === 0 ? "" : handleIsNext(false) }}>
                                            <i class="fa-regular fa-arrow-left mr-2"></i>
                                            Previous Lesson
                                        </a>
                                        {currecntScene + 1 !== getMyActivity?.secScCount && (
                                            <a href="javascript:void(0);"
                                            className={`${isShowLesson() ? "disabledevent" : ""}`}
                                            onClick={() => {
                                                isShowLesson() ? "" : handleIsNext(true)
                                            }}>
                                            Next Lesson <i class="fa-regular fa-arrow-right ml-2"></i>
                                        </a>
                                        )}
                                        
                                    </div>                                    
                                </>
                            )}
                            {getTab !== "Reflection" &&
                                (
                                    <CourseAbout
                                        courseData={courseInformationData?.records[0]}
                                        refrence={getMyActivity?.series?.reference}
                                        showProgress={showProgress}
                                        loginType={loginType}
                                        handlePlanGoals={handlePlanGoals}
                                        currentCourse={currentCourse}
                                    />
                                )
                            }
                           
                        </div>
                    ) : (
                        <ShimmerCategoryList items={4} categoryStyle="STYLE_SEVEN" />
                    )}

                </div>

                <CourseDetailRightPaenl
                    userPoint={userPoint}
                    getTab={getTab}
                    currentSceneObj={currentSceneObj}
                    handleIsNext={handleIsNext}
                    getMyActivity={getMyActivity}
                    loginType={loginType}
                    isBlink={isBlink}
                    getCount={getCount}
                    currentCourse={currentCourse}
                    setTab={setTab}
                />
            </div>
            {
                showCongratulationModel && (
                    <CongratulationCard
                        courseActivityId={courseActivityId}
                        handleOpenpopup={showScorCardpopUp}
                        isContinueButtonClick={false}
                    />
                )
            }
            
            {
                congratulationPopup && (
                    <LessonCongratulationsPopup
                        handleCongratulationPopup={showScorCardpopUp}
                        courseActivityId={courseActivityId}
                    />
                )
            }
        </MainLayOut>
    )
}
export default CourseDetail;